// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2fyZv","resendInfoText":"OnGoingPaymentBox_resendInfoText__3-9_1"};